/**
 * Make cart drawer / free-shipping amounts convertible by BUCKS:
 * wrap prices in span.money and call bucksCC.reConvert after updates.
 * Does not change currency itself.
 */
(function () {
  function shopMoneyFormat() {
    try {
      return (window.themeVariables && themeVariables.settings && themeVariables.settings.moneyFormat) || '{{amount}}';
    } catch (e) {
      return '{{amount}}';
    }
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = (cents == null || isNaN(cents) ? 0 : cents) / 100;
    var format = shopMoneyFormat();
    var placeholder = /\{\{\s*amount(?:_with_comma_separator|_no_decimals|_with_period_separator|_with_apostrophe_separator)?\s*\}\}/;

    function withSeparators(n, thou, dec, places) {
      var parts = n.toFixed(places).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return places ? parts.join(dec) : parts[0];
    }

    var formatted = format;
    if (formatted.indexOf('{{amount_with_comma_separator}}') !== -1) {
      formatted = formatted.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withSeparators(value, '.', ',', 2));
    } else if (formatted.indexOf('{{amount_no_decimals}}') !== -1) {
      formatted = formatted.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withSeparators(value, ',', '.', 0));
    } else if (formatted.indexOf('{{amount_with_period_separator}}') !== -1) {
      formatted = formatted.replace(/\{\{\s*amount_with_period_separator\s*\}\}/g, withSeparators(value, ' ', '.', 2));
    } else if (formatted.indexOf('{{amount_with_apostrophe_separator}}') !== -1) {
      formatted = formatted.replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withSeparators(value, "'", '.', 2));
    } else {
      formatted = formatted.replace(/\{\{\s*amount\s*\}\}/g, withSeparators(value, ',', '.', 2));
    }

    if (!/class=["']money["']/.test(formatted)) {
      formatted = '<span class="money">' + formatted + '</span>';
    }
    return formatted;
  }

  function reConvert() {
    try {
      if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') {
        window.bucksCC.reConvert();
      }
    } catch (e) {}
  }

  function patchFreeShippingBar() {
    var Ctor = customElements.get('free-shipping-bar');
    if (!Ctor || Ctor.prototype.__rbBucksPatched) return;
    Ctor.prototype.__rbBucksPatched = true;

    Ctor.prototype._updateMessage = function () {
      var messageElement = this.querySelector('span');
      if (!messageElement) return;

      if (this.totalPrice >= this.threshold) {
        messageElement.innerHTML = this.getAttribute('reached-message') || '';
      } else {
        var remaining = Math.max(0, this.threshold - this.totalPrice);
        var moneyHtml = formatMoney(remaining);
        var replacement = '<span class="bold text-accent">' + moneyHtml + '</span>';
        var unreached = this.getAttribute('unreached-message') || '';
        messageElement.innerHTML = unreached.replace(new RegExp('({{.*}})', 'g'), replacement);
      }
      reConvert();
    };

    // Refresh any already-mounted bars
    document.querySelectorAll('free-shipping-bar').forEach(function (el) {
      try {
        el._updateMessage();
      } catch (e) {}
    });
  }

  function wrapBarePrices(root) {
    if (!root) return;
    // Checkout button text often has "CHECKOUT  •  €xx" without money class
    root.querySelectorAll('.cart-drawer__buy-buttons .button, .cart-drawer [slot="footer"] .button').forEach(function (btn) {
      if (btn.querySelector('.money')) return;
      var html = btn.innerHTML;
      // If already has money span, skip
      if (/class=["']money["']/.test(html)) return;
    });
  }

  customElements.whenDefined('free-shipping-bar').then(patchFreeShippingBar);
  if (customElements.get('free-shipping-bar')) patchFreeShippingBar();

  document.addEventListener('cart:change', function () {
    setTimeout(reConvert, 50);
    setTimeout(reConvert, 300);
  });

  document.addEventListener('variant:add', function () {
    setTimeout(reConvert, 100);
  });

  // When drawer opens / content swaps
  var drawer = document.getElementById('cart-drawer');
  if (drawer && window.MutationObserver) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(reConvert, 80);
    }).observe(drawer, { childList: true, subtree: true });
  }

  // First paint
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(reConvert, 200);
    });
  } else {
    setTimeout(reConvert, 200);
  }


  /* --- Hide EUR flash on variant change while BUCKS reconverts to MDL/etc. --- */
  (function priceFlashGuard() {
    var CLS = 'rb-price-converting';
    var lastNonShop = false;

    function shopIsEur() {
      return true; // store currency is EUR
    }

    function sampleProductPrices() {
      var root = document.querySelector('.product-info__price') || document.querySelector('product-info') || document.querySelector('.product-info');
      return root ? (root.textContent || '') : '';
    }

    function bucksCurrency() {
      try {
        if (!window.bucksCC) return null;
        var b = window.bucksCC;
        var c = b.currency || b.currentCurrency || b.selectedCurrency || b.userCurrency;
        return c ? String(c).toUpperCase() : null;
      } catch (e) {
        return null;
      }
    }

    function textLooksConverted(t) {
      t = String(t || '').toUpperCase();
      return /MDL|\bLEI\b|\bRON\b|\bUSD\b|\bGBP\b|\bPLN\b|\bCZK\b/.test(t);
    }

    function textLooksEur(t) {
      t = String(t || '').toUpperCase();
      return t.indexOf('€') !== -1 || /\bEUR\b/.test(t);
    }

    function rememberCurrency() {
      var t = sampleProductPrices();
      var bc = bucksCurrency();
      if (bc && bc !== 'EUR') lastNonShop = true;
      if (textLooksConverted(t)) lastNonShop = true;
      if (bc === 'EUR' && textLooksEur(t) && !textLooksConverted(t)) lastNonShop = false;
    }

    function setHidden(on) {
      var nodes = document.querySelectorAll('.product-info__price, .product-info .price-list, product-info .price-list');
      nodes.forEach(function (el) {
        if (on) el.classList.add(CLS);
        else el.classList.remove(CLS);
      });
      if (on) document.documentElement.classList.add(CLS);
      else document.documentElement.classList.remove(CLS);
    }

    function waitConverted() {
      if (!lastNonShop && !textLooksConverted(sampleProductPrices()) && bucksCurrency() !== 'MDL') {
        // If we never saw a non-EUR display, don't hide (EUR shoppers)
        rememberCurrency();
        if (!lastNonShop) return;
      }
      setHidden(true);
      reConvert();
      var n = 0;
      var id = setInterval(function () {
        reConvert();
        var t = sampleProductPrices();
        var done = textLooksConverted(t) || (bucksCurrency() && bucksCurrency() !== 'EUR' && !textLooksEur(t));
        // Safety: if still EUR after many ticks but bucks says EUR, show anyway
        if (!done && bucksCurrency() === 'EUR') done = true;
        if (done || ++n > 50) {
          clearInterval(id);
          setHidden(false);
          // Keep SAVE % lock if present
          try {
            document.querySelectorAll('[data-rb-save-lock]').forEach(function (el) {
              var want = (el.getAttribute('data-rb-save-lock') || '').trim();
              if (want && (el.textContent || '').trim() !== want) el.textContent = want;
            });
          } catch (e) {}
        }
      }, 40);
    }

    document.addEventListener('variant:change', function () {
      rememberCurrency();
      waitConverted();
    });

    // Initial note after BUCKS first convert
    setTimeout(rememberCurrency, 600);
    setTimeout(rememberCurrency, 1500);
    document.addEventListener('currency:changed', rememberCurrency);
    document.addEventListener('bucks:currencyChanged', function () {
      rememberCurrency();
      setHidden(false);
    });
  })();

})();
